import { EDOCSIGNPROVIDER_TOKEN, EDOCSIGNPROVIDER_URL } from 'utils/constants'
import { useTranslation } from 'react-i18next'

export const createIframeUrl = (contractId: string, mexicanTaxpayerId: any) => {
  return (
    `${EDOCSIGNPROVIDER_URL}/public/sign/` +
    `${contractId}?token=` +
    `${EDOCSIGNPROVIDER_TOKEN}&legalRfc=` +
    `${mexicanTaxpayerId}`
  )
}

export const eDocSignProviderAPIData = {
  data: [],
  contract: {
    title: 'Contrato Conekta',
    description: 'Contrato para llevar a cabo operaciones con Conekta'
  },
  token: EDOCSIGNPROVIDER_TOKEN
}

export const getUserName = (name: string) => {
  const { t } = useTranslation()
  const GREETING = t('contract.greeting')
  return name ? `${GREETING} ${name},` : `${GREETING},`
}
